/** 库内 rarity 枚举（hub 仅允许 common / rare / epic） */
export const MEDAL_RARITY_VALUES = ["common", "rare", "epic"] as const;

export type MedalRarityValue = (typeof MEDAL_RARITY_VALUES)[number];

/** rarity → 展示等级 Lv.1～Lv.3 */
export const MEDAL_RARITY_TO_LEVEL: Record<string, number> = {
  common: 1,
  rare: 2,
  epic: 3,
  /** 历史数据，展示同 Lv.3 */
  legendary: 3,
};

export function normalizeMedalRarity(
  rarity: string | null | undefined
): MedalRarityValue | null {
  const key = String(rarity ?? "")
    .trim()
    .toLowerCase();
  if (!key) return null;
  if (key === "legendary") return "epic";
  if ((MEDAL_RARITY_VALUES as readonly string[]).includes(key)) {
    return key as MedalRarityValue;
  }
  return null;
}

export function formatMedalLevel(rarity: string | null | undefined): string {
  const key = String(rarity ?? "")
    .trim()
    .toLowerCase();
  if (!key) return "—";
  const level = MEDAL_RARITY_TO_LEVEL[key];
  if (level != null) return `Lv.${level}`;
  return String(rarity);
}

export function parseMedalLevelLabel(label: string): MedalRarityValue | null {
  const m = /^Lv\.(\d+)$/i.exec(String(label).trim());
  if (!m) return null;
  const level = Number(m[1]);
  if (level < 1 || level > 3) return null;
  const hit = Object.entries(MEDAL_RARITY_TO_LEVEL).find(
    ([rarity, n]) => n === level && rarity !== "legendary"
  );
  return (hit?.[0] as MedalRarityValue) ?? null;
}

/** 后管 / C 端下拉：展示 Lv.n，提交仍为 rarity 枚举 */
export const MEDAL_LEVEL_SELECT_OPTIONS = MEDAL_RARITY_VALUES.map((value) => ({
  value,
  label: formatMedalLevel(value),
}));
